import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

type LegacyCompanyRedirectProps = {
  to: (params: Record<string, string | undefined>) => string;
};

const LegacyCompanyRedirect: React.FC<LegacyCompanyRedirectProps> = ({ to }) => {
  const params = useParams();
  return <Navigate to={to(params as Record<string, string | undefined>)} replace />;
};

export default LegacyCompanyRedirect;
